import $ from 'jquery';

export default function collectDataAttributesFor(el, {prefix, camelize=true}){
  const data = {};
  let rgx = new RegExp(`^data-`);
  let numbToDash = 5;
  if(prefix){
    numbToDash = numbToDash + prefix.length + 1;
    rgx = new RegExp(`^data-${prefix}-`);
  }
  const $el = $(el);
  [].forEach.call(el.attributes || [], function(attr) {
    if (rgx.test(attr.name)) {
      let key = attr.name.substr(numbToDash);
      if(camelize){
        key = key.replace(/-(.)/g, function ($0, $1) {
          return $1.toUpperCase();
        });
      }
      // example: attr.name = "data-s2-whatever" 
      // so we need to remove "data-" from it
      // so then we can use jquery for it's smart
      // data attribute getter/setter
      const jqDataAttrName = attr.name.substr(5);
      data[key] = $el.data(jqDataAttrName);
    }
  });
  return data;
}


// WEBPACK FOOTER //
// ./src/utilities/collectDataAttributesFor/index.js